import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {environment} from 'src/environments/environment';
import { UtilityService } from '../utils/utility.service';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
  private path = `${environment.baseUrl}`;
  public headerParams:any;
  public generalHttpOptions:any;
  public companyMarkets

  constructor(private http: HttpClient, private utility: UtilityService) {
   if(localStorage.getItem('companyMarkets'))  this.companyMarkets = JSON.parse(localStorage.getItem('companyMarkets'));
    //console.log('Service markets', this.companyMarkets)
    this.headerParams = {
      'X-Country': this.utility.userMarket,
      // 'X-Lang': this.companyMarkets.find(x => x.country == this.utility.userMarket)?.lang ?? 'en',
      'X-Lang': 'en',
    }
    this.generalHttpOptions = {
      headers: new HttpHeaders(this.headerParams)
    }
  }

  public authenticate() {
    return this.http.get<any>(`${this.path}/login`, this.generalHttpOptions)
  }
 
}
